import React, { useState } from "react";
import "./FAQ.css";

const FAQ = ({ faqData }) => {
  const [activeFaq, setActiveFaq] = useState("");

  const toggleFaq = (faqId) => {
    setActiveFaq(activeFaq === faqId ? "" : faqId);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h1 className="faq-heading">
          Frequently Asked <span className="highlighted">Questions</span>
        </h1>
        <div className="faq-list">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className={`faq-item ${activeFaq === faq.id ? 'active' : ''}`}
              onClick={() => toggleFaq(faq.id)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <span className="faq-icon">
                  {activeFaq === faq.id ? '−' : '+'}
                </span>
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ; 